// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__FrTuH","fluid":"Container_fluid__0v1mx","section":"Container_section__MvxMr"};